import { render } from "./EditAlbum.vue?vue&type=template&id=d647500c&scoped=true"
import script from "./EditAlbum.vue?vue&type=script&lang=js"
export * from "./EditAlbum.vue?vue&type=script&lang=js"

import "./EditAlbum.vue?vue&type=style&index=0&id=d647500c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d647500c"]])

export default __exports__